import * as React from 'react'

import { SelectionGroup } from '@/modules/drivers/context/TableContext'
import GroupViewRow from './GroupViewRow'
import BonusRewardRow from './BonusRewardRow'
import { TimesheetRowData } from '../../views/Group.types'
import { withRouter, RouteComponentProps } from '@/app/navigation/withRouter'

/**
 * View mode type for timesheet display
 * - 'group-view': Group view (widok grupowy) - shows calculation status, costs, gross total
 * - 'bonus-reward': Bonus and reward view (premia i nagroda) - shows vacation, sick leave, netto amounts, rewards
 */
export type TimesheetViewMode =
  | 'group-view'
  | 'bonus-reward'
  | 'schedule'
  | 'single-view'

interface TimesheetTableRowProps extends RouteComponentProps {
  data: TimesheetRowData
  viewMode: TimesheetViewMode
  showBonusFields?: boolean
  selectedIds?: SelectionGroup
  isSelectedAny?: boolean
  companyId: string
  selectedYear?: number
}

/**
 * TimesheetTableRow - Wrapper component that selects the appropriate row component
 * based on the viewMode prop
 */
const TimesheetTableRow: React.FC<TimesheetTableRowProps> = ({
  data,
  viewMode,
  showBonusFields = false,
  selectedIds,
  isSelectedAny = false,
  companyId,
  selectedYear,
}) => {
  const isSelected =
    selectedIds?.ids.some((id) => String(id) === String(data.id)) ?? false
  const isDeemphasized = isSelectedAny && !isSelected

  if (viewMode === 'bonus-reward') {
    return (
      <BonusRewardRow
        data={data}
        showBonusFields={showBonusFields}
        selectedIds={selectedIds}
        isSelectedAny={isSelectedAny}
        style={isDeemphasized ? { opacity: 0.5 } : undefined}
      />
    )
  }

  // Default to group-view
  return (
    <GroupViewRow
      data={data}
      selectedIds={selectedIds}
      isSelectedAny={isSelectedAny}
      companyId={companyId}
      selectedYear={selectedYear}
      style={isDeemphasized ? { opacity: 0.5 } : undefined}
    />
  )
}

export default withRouter(TimesheetTableRow)
